// @flow

//
// FP
//
import S, { F } from '../../../../lib/trix-fp-fantasy';

//
// Trix Middleware
//
import {
    post as httpPost,
} from '../../../../lib/trix-web-middleware-commons';

import { push } from 'redux-first-history';

// createSaleIfMissing :: SaleSaleItemResult -> Future Error SaleSaleItemResult
const createSaleIfMissing = (sale: any) => (saleSaleItemResult: any) => {
    return new F.Future((reject, resolve) => {
        if (sale && sale.id) {
            resolve({
                ...saleSaleItemResult,
                sale,
            });
        } else {
            // call api to create sale
            const url = sale._links.createSale.href;
            const request = {};
            httpPost(
                url, request, 
                
                // reject,
                (error) => {
                    reject(
                        {
                            ...saleSaleItemResult,
                            createSale: {
                                status: 'ERROR',
                                error
                            }
                        }
                    );
                },

                // resolve
                (data) => {
                    resolve(
                        {
                            ...saleSaleItemResult,
                            sale: data.body,
                            createSale: {
                                status: 'SUCCESS',
                                data: data.body
                            }
                        }
                    );
                });
        }

        // TODO: fix after migration to Axious. Check how to add AbortController 
        // to axious call
        return () => null;
    });
};

// addSaleItem :: SaleSaleItemResult -> Future Error SaleSaleItemResult
const addSaleItem = (stock: any) => (saleSaleItemResult: any) => {
    return new F.Future((reject, resolve) => {
        if (!saleSaleItemResult || !saleSaleItemResult.sale || !saleSaleItemResult.sale) {
            return saleSaleItemResult;
        }

        // call api to create sale
        const url = saleSaleItemResult.sale._links.addItem.href;
        const request = {
            sku: stock.stock.sku,
            quantity: { amount: 1.0, unit: 'PCS' }
        };
        httpPost(
            url, request, 
            
            // reject,
            (error) => {
                reject(
                    {
                        ...saleSaleItemResult,
                        addSaleItem: {
                            status: 'ERROR',
                            error
                        }
                    }
                );
            },

            // resolve
            (data) => {
                resolve(
                    {
                        ...saleSaleItemResult,
                        addSaleItem: {
                            status: 'SUCCESS',
                            data: data.body
                        }
                    }
                );
            }
        );
        
        // TODO: fix after migration to Axious. Check how to add AbortController 
        // to axious call
        return () => null;
    });
};

// addSaleItem :: Action -> Future Error Data
const buildCreateSaleIfMissingAndAddSaleItem = (env: any): any => (data: any, container: any, meta?: any): any => (cfg: any): any => (action: any) => {
    return S.pipe([
        // SaleSaleItemResult -> Future () SaleSaleItemResult
        F.resolve,

        // Future () SaleSaleItemResult -> Future Error SaleSaleItemResult
        S.chain (createSaleIfMissing(container)),

        // Future Error SaleSaleItemResult -> Future Error SaleSaleItemResult
        S.chain (addSaleItem (data)),

        // Future Error SaleSaleItemResult -> Future Error SaleSaleItemResult
        S.map((saleSaleItemResult: any) => {
            const actions: Array<any> = [];
            let isSuccess = true;
            let error = null;

            if (saleSaleItemResult.createSale) {
                if (saleSaleItemResult.createSale.status === 'SUCCESS') {
                    env.relativeNavigateTo(`/${saleSaleItemResult.createSale.data.id}`);
                    
                    // const setSaleActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer';
                    // actions.push(
                    //     env.ducks.actions[setSaleActionId].data.setData(saleSaleItemResult.createSale.data)
                    // );
                }
                if (saleSaleItemResult.createSale.status === 'ERROR') {
                    isSuccess = false;
                    error = saleSaleItemResult.createSale.error;
                }
            }

            if (saleSaleItemResult.addSaleItem) {
                if (saleSaleItemResult.addSaleItem.status === 'SUCCESS') {
                    const addSaleLineActionId = 'trix-web-plugin-wms-retail-sale.manageRetailSalePage.root.manageRetailSaleContainer.currentRetailSaleLinesTable';
                    actions.push(
                        env.ducks.actions[addSaleLineActionId].data.addItem(saleSaleItemResult.addSaleItem.data)
                    );
                }
                if (saleSaleItemResult.addSaleItem.status === 'ERROR') {
                    isSuccess = false;
                    error = saleSaleItemResult.addSaleItem.error;
                }
            }

            if (isSuccess) {
                // complete execution with success
                actions.push(cfg.actions.operationExecuted_Success(saleSaleItemResult.addSaleItem.data));

                if (action.meta && action.meta.onSuccess) {
                    action.meta.onSuccess(saleSaleItemResult.addSaleItem.data);
                }
            } else {
                // complete execution with failure
                actions.push(cfg.actions.operationExecuted_Failure(error));
            }

            return actions;
        })
    ]) ({});
}

export default buildCreateSaleIfMissingAndAddSaleItem;